import * as React from "react";
import { observer } from "mobx-react-lite";
import { Route, Routes } from "react-router-dom";
import { Mk8sDraftMobx } from "./../../../../mst/stores/mk8s.draft";
import { ProviderAzure } from "./azure";
import { ProviderAzureAdvanced } from "./advanced";
import { ProviderAzureNodePoolContainer } from "./nodePoolContainer";
import { ProviderAzureNodePoolAdd } from "./nodePoolAdd";
import { ProviderAzureNodePools } from "./nodePools";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderAzureRouteRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  return (
    <Routes>
      <Route index element={<ProviderAzure mk8s={mk8s} mk8sDraft={mk8sDraft} />} />
      <Route path={`-node-pools`} element={<ProviderAzureNodePools mk8s={mk8s} mk8sDraft={mk8sDraft} />} />
      <Route path={`-node-pools/-add`} element={<ProviderAzureNodePoolAdd mk8s={mk8s} mk8sDraft={mk8sDraft} />} />
      <Route path={`-node-pools/:index`} element={<ProviderAzureNodePoolContainer mk8s={mk8s} mk8sDraft={mk8sDraft} />} />
      <Route path={`-advanced`} element={<ProviderAzureAdvanced mk8s={mk8s} mk8sDraft={mk8sDraft} />} />
    </Routes>
  );
};

export const ProviderAzureRoute = observer(ProviderAzureRouteRaw);
